import { createSlice } from '@reduxjs/toolkit';
import { getEmailRecipientsData, getRecipientTypesData } from '../../api/emailRecipients';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    emailRecipients: [],
    notificationTypes: [],
    recipientTypes: [],
    sites: [],
  },
};

const slice = createSlice({
  name: 'emailRecipient',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getEmailRecipientsSuccess(state, action) {
      state.isLoading = false;
      //spread this in to the state so not to overwrite the state
      state.data = { ...state.data, ...action.payload }
    },

    getRecipientTypesSuccess(state, action) {
      state.isLoading = false;
      const { notificationTypes, recipientTypes } = action.payload;
      state.data.notificationTypes = notificationTypes;
      state.data.recipientTypes = recipientTypes;
    },

  },
});

// Reducer
export default slice.reducer;

export function getEmailRecipients() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getEmailRecipientsData();
      dispatch(slice.actions.getEmailRecipientsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRecipientTypes(siteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getRecipientTypesData(siteId);
      dispatch(slice.actions.getRecipientTypesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
